import { useState } from 'react';
import { useBuildingContext } from '../../../context/BuildingContext';
import { Divider, Radio } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import TabletHeader from '../../../components/Operations/TabletHeader';
import { ListMaterialReceiving } from '../../Material';
import {
	TABLET_TITLE_STYLE,
	TABLET_BACK_BUTTON_STYLE,
	TABLET_SEARCH_STYLE,
	TABLET_RADIO_GROUP_STYLE,
	TABLET_RADIO_BUTTON_STYLE,
} from '../../../components/Operations/tabletStyles';

const ReceivingPage = () => {
	const navigate = useNavigate();
	const { buildingId } = useBuildingContext();

	const queryParams = new URLSearchParams(location.search);

	const materialOrderLineItemStatus =
		queryParams.get('status') || 'Awaiting Delivery';
	const [status, setStatus] = useState(materialOrderLineItemStatus);

	return (
		<div className="flex flex-col w-full p-3">
			<TabletHeader
				title="Receiving"
				titleStyle={TABLET_TITLE_STYLE}
				showOnClickButton
				icon={<ArrowLeftOutlined />}
				buttonText="Back"
				actionButtonStyle={TABLET_BACK_BUTTON_STYLE}
				searchStyle={TABLET_SEARCH_STYLE}
				radioGroupStyle={TABLET_RADIO_GROUP_STYLE}
				handleOnClick={() => navigate('/tablet/operations')}
				onSearch={(value) => {
					queryParams.set('search', String(value));
					navigate({ search: queryParams.toString() });
				}}
				onRadioChange={(e) => {
					queryParams.set('status', String(e.target.value));
					navigate({ search: queryParams.toString() });
					setStatus(e.target.value);
				}}
				radioOptions={
					<>
						<Radio.Button
							value="Awaiting Delivery"
							style={TABLET_RADIO_BUTTON_STYLE}
						>
							Pending
						</Radio.Button>
						<Radio.Button value="All" style={TABLET_RADIO_BUTTON_STYLE}>
							All
						</Radio.Button>
					</>
				}
				radioValue={status}
			/>

			<Divider style={{ marginBottom: 5 }} />

			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<ListMaterialReceiving
					filter_status={status}
					is_tablet={true}
					building_id={buildingId ?? undefined}
				/>
			</div>
		</div>
	);
};

export default ReceivingPage;
